// Blog posts data
export const blogPosts = [
  {
    id: 1,
    slug: 'claude-code-what-it-actually-does',
    title: 'Claude Code: What It Actually Does (And Where It Falls Short)',
    excerpt: "It's not a chatbot with a terminal. It's something weirder and more useful than that. But it's also not magic, and I wish someone had told me that earlier.",
    date: 'March 2026',
    readTime: '8 min read',
    category: 'AI Engineering',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
    contentType: 'component',
    contentComponent: 'ClaudeCodeBlogContent'
  }
];

export const getBlogPost = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getRecentPosts = (count = 3) => {
  return blogPosts.slice(0, count);
};
